<template>
  <v-container>
    <v-row dense>
      <v-col>
        <v-text-field color="red" v-model="item.poll">
          <template v-slot:label>
            <span class="red--text">ID ankety - TOTO NEVYPLŇOVAŤ A NEMENIŤ</span>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-select v-model="item.type" :items="['ZRKADLA', 'NAZORY', 'TRIBUNAL']">
          <template v-slot:label>
            <span class="red--text">Typ zobrazenia výsledkov hlasovania</span>
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-text-field v-model="item.first_field" label="Znenie otázky v ankete"></v-text-field>
      </v-col>
    </v-row>
    <!-- <v-row dense> 
      <v-col>
        <v-text-field v-model="item.second_field" label="Druhe pole"></v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-text-field v-model="item.name" label="Nazov"></v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-text-field v-model="item.sub_title" label="Pod nazov"></v-text-field>
      </v-col>
    </v-row> -->

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Po kliknutí na otázku sa zobrazí tento text
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <editor v-model="item.description_click"></editor>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Doplnenie témy
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <editor v-model="item.description"></editor>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          Povedali, napísali niekde inde
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <editor v-model="item.sources"></editor>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row dense>
      <v-col cols="auto">
        <v-text-field v-model="item.order" label="Poradie" type="number"></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-checkbox v-model="item.calculation_reversed" label="Obrateny vypocet"></v-checkbox>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-file-input v-model="photo_file" accept="image/*" label="Foto" append-outer-icon="mdi-delete"
          @click:append-outer="removePhoto()"></v-file-input>
        <v-img v-if="item.photo" class="my-5" :src="item.photo" />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-file-input v-model="video_file" accept="video/*" label="Video" append-outer-icon="mdi-delete"
          @click:append="removeVideo()"></v-file-input>
        <div v-if="item.video" class="text-center">
          <video width="500" controls>
            <source :src="item.video" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </v-col>
    </v-row>

    <v-row dense v-if="admin">
      <v-col>
        <v-switch label="Zaradit do noviniek" v-model="item.news_include">
        </v-switch>
      </v-col>
      <v-col v-show="item.news_include">
        <v-datetime-picker label="Do kedy je v novinkach" v-model="item.news_date_to">
        </v-datetime-picker>
      </v-col>
      <v-col v-show="item.news_include">
        <v-text-field v-model="item.news_order" label="Poradie v novinkach" type="number"></v-text-field>
      </v-col>
    </v-row>


    <v-row justify="space-between" dense>
      <v-col align="left">
        <v-switch label="Aktivne" v-model="item.active"></v-switch>
      </v-col>

      <v-col align="left">
        <v-switch label="Diskusia" v-model="item.enabled_discussion"></v-switch>
      </v-col>

      <v-col align="left">
        <v-switch label="Hlasovanie povolene" v-model="item._enabled_voting"></v-switch>
      </v-col>

      <v-col align="right">
        <v-btn color="info" class="mr-10" @click="openNotificationDialog" v-if="item.id">Odoslať notifikáciu</v-btn>
        
        <v-btn color="error" class="mr-10" @click="remove()">Zmazat</v-btn>

        <v-btn color="primary" @click="save()">Ulozit</v-btn>
      </v-col>
    </v-row>

    <!-- Notification Dialog -->
    <v-dialog v-model="notificationDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Odoslať notifikáciu</v-card-title>
        <v-card-text>
          Naozaj chcete odoslať notifikáciu o tejto otázke všetkým používateľom, ktorí ju nemajú zablokovanú?
          <v-checkbox
            v-if="admin"
            v-model="notificationIsImportant"
            label="Dôležité (ignorovať blokovania)"
            color="red"
          ></v-checkbox>
          <v-checkbox
            v-model="notificationForceResend"
            label="Poslať znovu len nehlasujúcim"
            color="primary"
          ></v-checkbox>
          <div v-if="notificationIsImportant" class="red--text caption">
            Pozor: Toto nastavenie pošle notifikáciu VŠETKÝM používateľom bez ohľadu na ich nastavenia. Používajte len vo výnimočných prípadoch!
          </div>
          <v-divider class="my-3"></v-divider>
          <div v-if="notificationStatsLoading" class="caption">Načítavam štatistiky odoslaní...</div>
          <div v-else-if="notificationStats && notificationStats.statistics" class="caption">
            <div><strong>Počet odoslaní:</strong> {{ notificationStats.statistics.send_count || 0 }}</div>
            <div><strong>Poslední príjemcovia:</strong> {{ notificationStats.statistics.last_recipients || 0 }}</div>
            <div><strong>Celkovo príjemcov:</strong> {{ notificationStats.statistics.total_recipients || 0 }}</div>
            <div><strong>Typ posledného odoslania:</strong> {{ notificationStats.statistics.last_send_type || '-' }}</div>
            <div><strong>Naposledy odoslané:</strong> {{ notificationStats.statistics.last_sent_at | moment('YYYY-MM-DD HH:mm') }}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="notificationDialog = false">Zrušiť</v-btn>
          <v-btn color="primary" text @click="sendNotification" :loading="notificationLoading">Odoslať</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { APIService } from "@/http/APIService.js";
import Editor from "@/components/Editor.vue"
import moment from "moment";

const apiService = new APIService();

export default {
  props: {
    itemID: { type: Number, required: true },
    admin: { type: Boolean, required: false, default: true },
  },


  components: {
    Editor
  },

  data() {
    return {
      item: {},
      photo_file: null,
      video_file: null,
      notificationDialog: false,
      notificationIsImportant: false,
      notificationForceResend: false,
      notificationLoading: false,
      notificationStatsLoading: false,
      notificationStats: null
    }
  },

  mounted() {
    this.getItem();
  },

  methods: {
    removePhoto() {
      apiService.patchGeneralPollQuestionAdmin({ 'photo': null }, this.item.id).then(response => {
        this.$emit("sync-child");
        this.item = response;
        this.photo_file = null;
      });
    },

    removeVideo() {
      apiService.patchGeneralPollQuestionAdmin({ 'video': null }, this.item.id).then(response => {
        this.$emit("sync-child");
        this.item = response;
        this.video_file = null;
      });
    },

    save() {
      let formData = new FormData();

      for (var key in this.item) {
        if (key == "photo") continue;
        if (key == "video") continue;

        if (key == "news_date_to") {
          if (this.item[key])
            formData.set(key, moment(this.item[key]).format());
        }
        else if (this.item[key] != null) {
          formData.set(key, this.item[key]);
        }
      }

      if (this.photo_file instanceof File)
        formData.append("photo", this.photo_file);

      if (this.video_file instanceof File)
        formData.append("video", this.video_file);


      apiService.updateGeneralPollQuestionAdmin(formData, this.item.id).then(response => {
        this.$emit("sync-child");
        this.item = response;
      });
    },

    remove() {
      confirm("Naozaj zmazat?") && apiService.deleteGeneralPollQuestionAdmin(this.item.id).then(() => {
        this.$emit("sync-child");
      });
    },

    getItem() {
      apiService.getGeneralPollQuestionAdmin(this.itemID).then(response => {
        this.item = response;
      });
    },

    openNotificationDialog() {
      this.notificationDialog = true;
      this.fetchNotificationStats();
    },

    fetchNotificationStats() {
      this.notificationStatsLoading = true;
      apiService.getGeneralPollQuestionNotificationStatistics(this.item.id)
        .then(response => {
          this.notificationStats = response;
        })
        .catch(() => {
          this.notificationStats = null;
        })
        .finally(() => {
          this.notificationStatsLoading = false;
        });
    },

    sendNotification() {
      this.notificationLoading = true;
      apiService.sendGeneralPollQuestionNotification(this.item.id, this.notificationIsImportant, this.notificationForceResend)
        .then(response => {
          this.notificationDialog = false;
          alert(response.message || "Notifikácia bola úspešne odoslaná.");
          this.fetchNotificationStats();
        })
        .catch(error => {
          alert("Chyba pri odosielaní notifikácie.");
          console.error(error);
        })
        .finally(() => {
          this.notificationLoading = false;
        });
    }
  }
}
</script>